import { render, staticRenderFns } from "./menuInferior.vue?vue&type=template&id=58c111ce&scoped=true&lang=html&"
import script from "./menuInferior.vue?vue&type=script&lang=js&"
export * from "./menuInferior.vue?vue&type=script&lang=js&"
import style0 from "./menuInferior.vue?vue&type=style&index=0&id=58c111ce&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c111ce",
  null
  
)

export default component.exports